import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {HttpClientModule} from '@angular/common/http';

import { VendorModule } from '../core/vendor.module';
import { NgxMaskModule } from 'ngx-mask';

import { CoreModule } from '../core/core.module';
import { SecurityService } from '../security/security.service';
import { ClienteComponent } from './cliente.component';
import { ClienteListComponent } from './cliente-list/cliente-list.component';
import { LoguedGuardService } from '../security/logued-guard.service';
import { ClienteResolver } from './cliente.resolver';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SecurityModule } from '../security/security.module';
import { ClienteDetailsComponent } from './cliente-details/cliente-details.component';
import { ClienteFilterComponent } from './cliente-filter.component';
import { ClienteAddEditComponent } from './cliente-add-edit/cliente-add-edit.component';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { ClientesAprobadosListComponent } from './clientes-aprobados-list/clientes-aprobados-list.component';
import { SaldoResolver } from './saldos.resolver';
import { VerSaldosComponent } from './ver-saldos/ver-saldos.component';
import { ListadoClienteComponent } from './operaciones/listado-cliente/listado-cliente.component';
import { OperacionAddComponent } from './operaciones/operacion-add/operacion-add.component';
import { MotivosRechazo } from './motivosRechazo/motivosRechazo.model';
import { MotivosRechazoComponent } from './motivosRechazo/motivosRechazo.component';
import { MotivosRechazoListComponent } from './motivosRechazo/motivosRechazo-list.component';
import { MotivosRechazoAddEditComponent } from './motivosRechazo/motivosRechazo-add-edit.component';
import { MotivosRechazoResolver } from './motivosRechazo/motivosRechazo.resolver';
import { ClientesPendientesAprobacionListComponent } from './clientes-pendientes-aprobacion-list/clientes-pendientes-aprobacion-list.component';
import { ClienteTableComponent } from './cliente-table/cliente-table.component';
import { ClienteLogoUploadComponent } from './cliente-logo-upload/cliente-logo-upload.component';
import { ClienteUserAddEditComponent } from './cliente-user-add-edit/cliente-user-add-edit.component';
import { ClienteUserMontoMaxComponent } from './cliente-user-monto-max/cliente-user-monto-max.component';
import { VerAcuerdosComponent } from './ver-acuerdos/ver-acuerdos.component';
import { ClienteLogoListComponent } from './cliente-logo-list/cliente-logo-list.component';
import { SectorComponent } from './sectores/sector.component';
import { SectorResolver } from './sectores/sector.resolver';
import { SectorListComponent } from './sectores/sector-list.component';
import { SectorAddEditComponent } from './sectores/sector-add-edit.component';
import { ClienteUserMontoMaxMasivoComponent } from './cliente-user-monto-max-masivo/cliente-user-monto-max-masivo.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
    NgxMaskModule
  ],
  declarations: [
    ClienteComponent,
    ClienteListComponent,
    ClienteDetailsComponent,
    ClienteFilterComponent,
    ClienteAddEditComponent,
    ClientesAprobadosListComponent,
    VerSaldosComponent,
    ListadoClienteComponent,
    OperacionAddComponent,
    MotivosRechazoComponent,
    MotivosRechazoListComponent,
    MotivosRechazoAddEditComponent,
    ClientesPendientesAprobacionListComponent,
    ClienteTableComponent,
    ClienteLogoUploadComponent,
    ClienteUserAddEditComponent,
    ClienteUserMontoMaxComponent,
    VerAcuerdosComponent,
    ClienteLogoListComponent,
    SectorComponent,
    SectorListComponent,
    SectorAddEditComponent,
    ClienteUserMontoMaxMasivoComponent,
  ],
  exports: [
    ClienteComponent,
    ClienteListComponent
  ],
  providers: [
    SecurityService,
    LoguedGuardService,
    ClienteResolver,
    SaldoResolver,
    MotivosRechazoResolver,
    SectorResolver
  ]
})
export class ClienteModule { }



// WEBPACK FOOTER //
// ./src/app/cliente/cliente.module.ts